import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    console.log('Modal controller connected')
    this.modal = new bootstrap.Modal(this.modalTarget)
    this.show()
    this.setupFormListener()
    this.setupCloseListener()
  }

  disconnect() {
    console.log('Modal controller disconnecting')
    if (this.modal) {
      this.modal.dispose()
    }
  }

  setupFormListener() {
    const form = this.element.querySelector('form')
    if (form) {
      form.addEventListener('turbo:submit-end', (event) => {
        this.handleFormSubmit(event)
      })
    }
  }

  setupCloseListener() {
    this.modalTarget.addEventListener('hidden.bs.modal', () => {
      console.log('Modal hidden, removing modal content but keeping frame')
      this.element.remove()
    })
  }

  handleFormSubmit(event) {
    const { detail } = event

    if (detail.success) {
      this.close()
      window.location.reload()
    }
  }

  open(event) {
    event.preventDefault()
    this.show()
  }

  show() {
    this.modal.show()
  }

  close() {
    this.modal.hide()
  }
}

